@if (facet$ | async; as facet) {
    <form name="{{ 'form_' + facet.key }}" class="sh-facet">
        @if (collapsible) {
            <button type="button" class="sh-facet__header" (click)="onToggleExpanded()" [attr.aria-expanded]="expanded">
                <span class="sh-facet__label">{{ facet.label }}</span>
                <svg sh-icon name="angle-down" class="sh-facet__chevron" [class.sh-facet__chevron--expanded]="expanded"></svg>
            </button>
        } @else if (showLabel) {
            <label class="sh-facet__label">{{ facet.label }}</label>
        }
        @if (!collapsible || expanded) {
            @if (bodyTemplate) {
                <ng-container [ngTemplateOutlet]="bodyTemplate" [ngTemplateOutletContext]="{ $implicit: facet }"></ng-container>
            } @else {
                <ul class="sh-facet__values sh-form-check-list">
                    @for (facetValue of facet.values; track trackByLabel($index, facetValue)) {
                        <li class="sh-facet__values__value sh-form-check sh-form-check-list__item">
                            <div class="sh-form-check sh-form-check-list__item__check">
                                <input
                                    type="checkbox"
                                    id="{{
                                        facetDialogOpen
                                            ? 'dialog_facet_' + facet.key + '_value_' + facetValue.label
                                            : 'facet_' + facet.key + '_value_' + facetValue.label
                                    }}"
                                    class="sh-form-check__input"
                                    [ngClass]="facet.selectionType === ShFacetSelectionType.MUST ? 'sh-radio' : 'sh-checkbox'"
                                    name="{{ 'facet_' + facet.key }}"
                                    [value]="facetValue.value"
                                    [checked]="facetValue.selected"
                                    (change)="onSelectionChange(facet, facetValue)"
                                />
                                <label
                                    class="sh-form-check__label"
                                    for="{{
                                        facetDialogOpen
                                            ? 'dialog_facet_' + facet.key + '_value_' + facetValue.label
                                            : 'facet_' + facet.key + '_value_' + facetValue.label
                                    }}"
                                    [title]="facetValue | FacetValueLabel: facet.label : (noValueKey | translate) : noValueKey"
                                >
                                    <div class="sh-facet__values__value__text">
                                        {{ facetValue | FacetValueLabel: facet.label : (noValueKey | translate) : noValueKey }}
                                    </div>
                                    @if (facetValue.count > 0) {
                                        <div class="sh-facet__values__value__count">({{ facetValue.count }})</div>
                                    }
                                </label>
                            </div>
                        </li>
                    }
                </ul>
                @if (showLoadMore) {
                    <a
                        tabindex="0"
                        (click)="onShowMore(facet)"
                        class="sh-facet__more_link"
                        (keyup.Space)="onShowMore(facet)"
                        (keyup.Enter)="onShowMore(facet)"
                        >{{ showMoreMsg }}</a
                    >
                }
            }
        }
    </form>
}
